import { redirect } from "react-router";
import api from "./api";

export async function action({ params }) {
  const id = params.id;
  await api.delete(`/record/${id}`);
  return redirect("/list");
}
